import {
    TRANSACTION_HISTORY_REQUEST,
    TRANSACTION_HISTORY_SUCCESS,
    TRANSACTION_HISTORY_FAILURE,
} from './types';


const initialState = {
    
    loading: false,
    error: null,
    Transaction:[]
    
    
}

const transactionhistoryreducer = (state = initialState, action) => {

    switch (action.type) {
        case TRANSACTION_HISTORY_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case TRANSACTION_HISTORY_SUCCESS:{
            // const {email, password} = action.payload;
            
            return {
                ...state,
                loading: false,
                Transaction:action.payload
                
            }
        }
        case TRANSACTION_HISTORY_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.message,
            }

        default:
            return state
    }
}

export default transactionhistoryreducer